import React from "react"

import type { MetricRecordData } from "@/types/metrics/contracts"

import {
  FIELD_CONTAINER_STYLES,
  LABEL_ROW_STYLES,
  LABEL_STYLES,
  TEXT_INPUT_STYLES,
} from "../styles"

interface CustomAgentFailsToRespondConfigProps {
  metricRecordData: MetricRecordData
  onChange: (metric: MetricRecordData) => void
}

export const CustomAgentFailsToRespondConfig: React.FC<
  CustomAgentFailsToRespondConfigProps
> = ({ metricRecordData, onChange }) => {
  const handleMaxSilenceDurationChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = parseFloat(e.target.value)
    onChange({
      ...metricRecordData,
      metric_metadata: {
        ...metricRecordData.metric_metadata,
        max_silence_duration_seconds: isNaN(value) ? undefined : value,
      },
    })
  }

  return (
    <div className="space-y-4">
      <div className={FIELD_CONTAINER_STYLES}>
        <div className={LABEL_ROW_STYLES}>
          <label className={LABEL_STYLES}>
            Max Silence Duration (seconds){" "}
            <span className="text-coval-danger-text">*</span>
          </label>
        </div>
        <input
          type="number"
          step="0.5"
          min="0.1"
          className={TEXT_INPUT_STYLES}
          value={
            metricRecordData.metric_metadata?.max_silence_duration_seconds || ""
          }
          onChange={handleMaxSilenceDurationChange}
          placeholder="5.0"
        />
        <p className="text-xs text-coval-text-muted">
          If the agent is silent for longer than this after the user's last
          message, the metric reports failure.
        </p>
      </div>
    </div>
  )
}
